var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"maptitle"}},[_c('HomeButton',{attrs:{"backURL":_vm.themeURL}}),_c('h5',[_vm._v(_vm._s(_vm.mapTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }